import(/* webpackMode: "eager" */ "/codebuild/output/src1566136820/src/portal-v2/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1566136820/src/portal-v2/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PortalV1RootUrlProvider"] */ "/codebuild/output/src1566136820/src/portal-v2/src/client/components/portal-v1-url-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1566136820/src/portal-v2/src/client/components/ui/toast/index.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1566136820/src/portal-v2/src/client/components/ui/tooltip/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1566136820/src/portal-v2/src/client/i18n/i18-next-provider.tsx");
